import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseServiceFacade,
  GenericApiCall,
} from '../../../../common/store/types';
import { AppState } from '../../types';
import { WorkScheduleModel } from './types';
import { workScheduleActions } from './work-schedule.actions';
import { workScheduleSelectors } from './work-schedule.selector';

@Injectable()
export class WorkScheduleService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<WorkScheduleModel, number> = this.genericApiCall(
    workScheduleActions.getById,
    workScheduleSelectors.getById,
    true,
  );
  createInstance: GenericApiCall<WorkScheduleModel, void> =
    this.genericApiCall(
      workScheduleActions.createInstance,
      workScheduleSelectors.createInstance,
      true,
    );
  add: GenericApiCall<WorkScheduleModel, WorkScheduleModel> =
    this.genericApiCall(
      workScheduleActions.add,
      workScheduleSelectors.add,
      true,
    );
  update: GenericApiCall<WorkScheduleModel, WorkScheduleModel> =
    this.genericApiCall(
      workScheduleActions.update,
      workScheduleSelectors.update,
      true,
    );
  delete: GenericApiCall<boolean, number> = this.genericApiCall(
    workScheduleActions.delete,
    workScheduleSelectors.delete,
    true,
  );
}
